<template>
  <div :class="classes()"><slot /></div>
</template>

<script>
const cols = {
  type: Number,
  validator: (val) => [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].includes(val),
};

export default {
  name: 'Col',
  props: {
    /** 0px - 360px */
    xs: cols,
    /** 360px - 768px */
    s: cols,
    /** 769px - 1024px */
    m: cols,
    /** 1025px - 1200px */
    l: cols,
    /** 1201px - 1500px */
    xl: cols,
    /** 1501px > */
    xxl: cols,
    xsOffset: cols,
    sOffset: cols,
    mOffset: cols,
    lOffset: cols,
    xlOffset: cols,
    xxlOffset: cols,
    autoWidth: Boolean,
    center: Boolean,
    right: Boolean,
    hasMargin: Boolean,
    className: String,
  },
  data() {
    return {
      el: 'c-col',
      classes: () => {
        const el = this.el;
        return {
          [el]: true,
          [`${el}--${this.xs}@xs`]: this.xs,
          [`${el}--${this.s}@s`]: this.s,
          [`${el}--${this.m}@m`]: this.m,
          [`${el}--${this.l}@l`]: this.l,
          [`${el}--${this.xl}@xl`]: this.xl,
          [`${el}--${this.xxl}@xxl`]: this.xxl,
          [`${el}--${this.xsOffset}-offset@xs`]: typeof this.xsOffset === 'number',
          [`${el}--${this.sOffset}-offset@s`]: typeof this.sOffset === 'number',
          [`${el}--${this.mOffset}-offset@m`]: typeof this.mOffset === 'number',
          [`${el}--${this.lOffset}-offset@l`]: typeof this.lOffset === 'number',
          [`${el}--${this.xlOffset}-offset@xl`]: typeof this.xlOffset === 'number',
          [`${el}--${this.xxlOffset}-offset@xxl`]: typeof this.xxlOffset === 'number',
          [`${el}--autoWidth`]: this.autoWidth,
          [`${el}--center`]: this.center,
          [`${el}--right`]: this.right,
          [`${el}--hasMargin`]: this.hasMargin,
        };
      },
    };
  },
};
</script>
